import * as Joi from 'joi';

const rejectRequest = Joi.object({
  reason: Joi.string().trim().min(1).max(255).required().messages({
    'any.required': `Reason is not allowed to be empty`,
    'string.max': `Exceed the maximum character`,
  }),
});

export default rejectRequest;
